// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bv1ejb{padding-left:var(--ds-space-300,24px)}\n._19pku2gc{margin-top:var(--ds-space-100,8px)}\n._ca0q1ejb{padding-top:var(--ds-space-300,24px)}\n._n3td1ejb{padding-bottom:var(--ds-space-300,24px)}\n._syaz1wmz{color:var(--ds-text-subtlest,#6b778c)}\n._u5f31ejb{padding-right:var(--ds-space-300,24px)}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
